export default __webpack_public_path__ + "static/media/Tfroce freight.5dbe82cf.png";